<template>
  <Input
    v-model="item.value.singleLineTextAttribute.answer"
    :placeholder="fillBlankPlaceholder + minWordQuantity + maxWordQuantity + verifyIdCard + verifyPhone"
    @on-change="singleTextChange(item,item.value.singleLineTextAttribute.answer)"
  />
</template>
<script>
export default {
  props: ['item'],

  data() {
    return {
      fillBlankPlaceholder: '请输入',
      minWordQuantity: '',
      maxWordQuantity: '',
      verifyIdCard: '',
      verifyPhone: '',
      windowHeight: document.body.scrollHeight,
    }
  },
  created: function () {
    this.minWordQuantity = this.item.value.singleLineTextAttribute
      .minWordQuantity
      ? '(最少填' +
        this.item.value.singleLineTextAttribute.minWordQuantity +
        '字)'
      : ''
    this.maxWordQuantity = this.item.value.singleLineTextAttribute
      .maxWordQuantity
      ? '(最多填' +
        this.item.value.singleLineTextAttribute.maxWordQuantity +
        '字)'
      : ''
    this.verifyIdCard = this.item.value.singleLineTextAttribute.verifyIdCard
      ? '(请输入身份证号码)'
      : ''
    this.verifyPhone = this.item.value.singleLineTextAttribute.verifyPhone
      ? '(请输入手机号码)'
      : ''
    this.fillBlankPlaceholder = this.item.value.singleLineTextAttribute
      .defaultValue
      ? this.item.value.singleLineTextAttribute.defaultValue
      : ''
  },
  methods: {
    //  单行文本验证 this.item.value.singleLineTextAttribute.errorMessage != "" ||
    singleTextChange: function (data, val) {
      this.item.value.singleLineTextAttribute.verifyStatus = true
      // 最大值和最小值身份证和手机号码验证
      // if(data.value.singleLineTextAttribute.minWordQuantity != "" ||  data.value.singleLineTextAttribute.maxWordQuantity !=""){
      if (
        val.length <
          Number(data.value.singleLineTextAttribute.minWordQuantity) &&
        data.value.singleLineTextAttribute.minWordQuantity
      ) {
        this.$Message.warning(
          data.value.singleLineTextAttribute.errorMessage != ''
            ? data.value.singleLineTextAttribute.errorMessage
            : '最少填' +
                data.value.singleLineTextAttribute.minWordQuantity +
                '字'
        )
        this.item.value.singleLineTextAttribute.verifyStatus = false
        // data.value.singleLineTextAttribute.answer = ""
      } else if (
        val.length >
          Number(data.value.singleLineTextAttribute.maxWordQuantity) &&
        data.value.singleLineTextAttribute.maxWordQuantity
      ) {
        this.$Message.warning(
          data.value.singleLineTextAttribute.errorMessage != ''
            ? data.value.singleLineTextAttribute.errorMessage
            : '最多填' +
                data.value.singleLineTextAttribute.maxWordQuantity +
                '字'
        )
        this.item.value.singleLineTextAttribute.verifyStatus = false
        // data.value.singleLineTextAttribute.answer = ""
      } else if (data.value.singleLineTextAttribute.verifyIdCard == true) {
        const idcardReg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/
        if (idcardReg.test(val)) {
        } else {
          this.$Message.warning(
            data.value.singleLineTextAttribute.errorMessage != ''
              ? data.value.singleLineTextAttribute.errorMessage
              : '请输入正确的身份证号码'
          )
          this.item.value.singleLineTextAttribute.verifyStatus = false
          // data.value.singleLineTextAttribute.answer = ""
        }
      } else if (data.value.singleLineTextAttribute.verifyPhone == true) {
        const phoneReg = /^(13[0-9]|14[5|7]|15[0|1|2|3|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\d{8}$/
        if (phoneReg.test(val)) {
        } else {
          this.$Message.warning(
            data.value.singleLineTextAttribute.errorMessage != ''
              ? data.value.singleLineTextAttribute.errorMessage
              : '请输入正确的手机号码'
          )
          this.item.value.singleLineTextAttribute.verifyStatus = false
          // data.value.singleLineTextAttribute.answer = ""
        }
      }
    },
  },
}
</script>
<style lang="less">
</style>


